import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter } from 'react-router-dom';
import App from './App';
import './css/App.css';
import './css/main.css';
import './css/dialogs.css';
import './css/versions.css';
import './css/clients.css';
import './css/features.css';
import './css/contact.css';
import './css/error.css';
import './css/compatibility.css';
import './css/carousel.css';
  
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <React.StrictMode>
      <BrowserRouter>
        <App/>
      </BrowserRouter>
  </React.StrictMode>
);